module.exports = __webpack_public_path__ + "img/海边.2d727d01.png";